import './design-system.css';
import React, { ReactNode } from 'react';
import { useCurrentUser } from './App.hooks';
import AppShell from './components/AppShell';
import SpinnerNew from './components/main/SpinnerNew/SpinnerNew';
import { TagTypeColourProvider } from './contexts/TagTypeColourContext';

type AppProps = {
  children?: ReactNode | undefined,
};

function App(props: AppProps) {
  const currentUser = useCurrentUser();

  return (
    <div className="h-full w-full">
      {currentUser ?
        <TagTypeColourProvider>
          <AppShell />
        </TagTypeColourProvider>
        : <SpinnerNew size="large" label="Loading..." />
      }
    </div>
  );
}

export default App;
